import { useFetch } from '@reveni-io/reveni-ui'

import commonServices from '@/common/services/services'

import { transformResponseGetRuleFeatures } from './transformers'

const useRuleFeatures = ({ storeId }) => {
  const { data: ruleFeatures, loading: fetchingRuleFeatures } = useFetch(
    () => commonServices.getRuleFeatures({ storeId }),
    {
      doInitialRequest: true,
      transformResponse: transformResponseGetRuleFeatures,
    }
  )

  return {
    disabledActions: ruleFeatures?.disabled_actions || [],
    disabledConditionFields: ruleFeatures?.disabled_condition_fields || [],
    disabledTriggers: ruleFeatures?.disabled_triggers || [],
    fetchingRuleFeatures,
  }
}

export default useRuleFeatures
